import { createQueryKeyStore } from "@lukemorales/query-key-factory";

import { getIntakeFormByBmi } from "./intake";

export const questionnaireQueriesStore = createQueryKeyStore({
  intake: {
    form: (params: { bmi: number; state?: string }) => ({
      queryKey: [{ params }],
      queryFn: () => getIntakeFormByBmi(params),
      staleTime: Infinity,
    }),
  },
});
